import { Button } from "antd"
import classNames from "classnames"

import styles from "./MainButton.module.scss"

function MainButton({ ...restProps }) {
  return (
    <Button
      {...restProps}
      className={classNames(styles.button, restProps.className)}
    />
  )
}

export default MainButton
